import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../../app.settings';


@Injectable({
  providedIn: 'root'
})

export class UserService{
    userListUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'users'}/${'all'}`;
    userUpdateUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'users'}`;
    addUserUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'users'}`;
    deleteUserUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'users'}`;
    deactivateUserUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'user-activate-deactivate'}`;
    changePasswordUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'change_password'}`;
    resetPasswordUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'reset_password'}`;
    userRoleListUrl = AppSettings.EMAIL_API_ENDPOINT+'/roles'; 
    teamListUrl = AppSettings.EMAIL_API_ENDPOINT+'/teams/all'; 
    teamsUrl=AppSettings.EMAIL_API_ENDPOINT+'/teams';
     CurrentUserUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'loggedin_user'}`;

    constructor(private http: HttpClient) { }

  getUserList(payload:any){
    return this.http.post(this.userListUrl,payload);
  }

  updateUser(data:any){
    return this.http.put(this.userUpdateUrl, data);
  }

  addUser(data:any){
    return this.http.post(this.addUserUrl,data);
  }

  deleteUser(id:string){
    return this.http.delete(`${this.deleteUserUrl}/${id}`);
  }

  deactivateUser(data:any){
    return this.http.post(this.deactivateUserUrl, data);
  }

  changePassword(data:any){
    return this.http.post(this.changePasswordUrl, data);
  }

  resetPassword(data:any){
    return this.http.post(this.resetPasswordUrl,data);
  }

  getuserRoleList(){
    return this.http.get(this.userRoleListUrl);
  }

  getTeamsList(payload:any){
    return this.http.post(this.teamListUrl,payload);
  }

  saveTeams(payload:any){
   return this.http.post(this.teamsUrl,payload);
  }

  updateTeams(payload:any){
    return this.http.put(this.teamsUrl,payload);
   }

  deleteTeams(team_id:any){
    return this.http.delete(this.teamsUrl+"/"+team_id);
  }
    getCurrentUser(){
      return this.http.get(this.CurrentUserUrl);
    }

}